import InnerNav from "../../../components/InnerNav/InnerNav";
import Zodiac from "../../../components/ZodiacSign/Zodiac";
import Footer from "../../../components/Footer/Footer";
import arrow from "../../../assets/arrow.png";
import axios from "axios";
import { useState } from "react";
import { Link } from "react-router-dom";
import "./Path.scss";

// ⭐ LIFE PATH NUMBER PROFILES (like lucky & destiny)
export const pathProfiles = {
  1: {
    title: "Life Path 1 – The Leader",
    keywords: "Independence · Ambition · Self-belief",
    overview:
      "Life Path 1 represents originality, confidence and inner drive. You are here to lead, innovate and build your own path.",
    strengths: [
      "Natural leadership and strong determination",
      "Independent thinking and courage",
      "Ability to initiate and take action",
    ],
    challenges: [
      "Impatience and stubbornness",
      "Difficulty accepting guidance",
      "Fear of failure hidden behind confidence",
    ],
    guidance:
      "Use leadership with humility. Collaboration will take you further than working alone.",
  },

  2: {
    title: "Life Path 2 – The Peacemaker",
    keywords: "Harmony · Sensitivity · Partnership",
    overview:
      "You are naturally intuitive, gentle, cooperative and diplomatic. You bring balance and healing wherever you go.",
    strengths: [
      "Strong intuition and emotional intelligence",
      "Excellent teamwork and mediation skills",
      "Calming and supportive presence",
    ],
    challenges: [
      "Oversensitivity",
      "Avoiding conflict even when needed",
      "Self-doubt and dependence on validation",
    ],
    guidance:
      "Stand up for yourself. Your harmony grows stronger when grounded in confidence.",
  },

  3: {
    title: "Life Path 3 – The Communicator",
    keywords: "Creativity · Expression · Joy",
    overview:
      "Life Path 3 carries artistic talent, charm and communication ability. You uplift others with your words and presence.",
    strengths: [
      "Creative expression and imagination",
      "Strong communication abilities",
      "Optimistic and inspiring energy",
    ],
    challenges: [
      "Lack of discipline",
      "Scattered focus",
      "Avoiding deeper emotional issues",
    ],
    guidance:
      "Structure your creativity—discipline will unlock big achievements.",
  },

  4: {
    title: "Life Path 4 – The Builder",
    keywords: "Stability · Structure · Hard work",
    overview:
      "You bring order, discipline and reliability. You excel in building long-term foundations and systems.",
    strengths: [
      "Organized and methodical",
      "Strong work ethic",
      "Loyal and trustworthy",
    ],
    challenges: [
      "Rigidity and resistance to change",
      "Workaholic tendencies",
      "Difficulty adapting quickly",
    ],
    guidance:
      "Balance discipline with flexibility. Innovation and structure can co-exist.",
  },

  5: {
    title: "Life Path 5 – The Explorer",
    keywords: "Freedom · Adventure · Change",
    overview:
      "Dynamic, curious and fearless—Life Path 5 brings movement, experience and transformation.",
    strengths: [
      "Adaptable and adventurous spirit",
      "Quick learner",
      "Excellent communicator",
    ],
    challenges: [
      "Restlessness",
      "Difficulty committing",
      "Impulsive decisions",
    ],
    guidance:
      "Freedom becomes powerful when directed toward meaningful goals.",
  },

  6: {
    title: "Life Path 6 – The Nurturer",
    keywords: "Responsibility · Care · Harmony",
    overview:
      "Life Path 6 is about love, service and responsibility. You bring healing, harmony and support to others.",
    strengths: [
      "Compassionate and caring nature",
      "Strong sense of responsibility",
      "Artistic and family-oriented",
    ],
    challenges: [
      "Over-giving",
      "Taking on others' burdens",
      "Feeling unappreciated",
    ],
    guidance:
      "Set boundaries. Self-care strengthens your ability to help others.",
  },

  7: {
    title: "Life Path 7 – The Seeker",
    keywords: "Wisdom · Intuition · Depth",
    overview:
      "You are spiritual, analytical and introspective. You seek truths beyond the surface.",
    strengths: [
      "Deep thinker and researcher",
      "Highly intuitive and perceptive",
      "Calm and observant",
    ],
    challenges: [
      "Isolation and emotional distance",
      "Overthinking",
      "Difficulty expressing emotions",
    ],
    guidance:
      "Share your wisdom—your insights are meant to be heard.",
  },

  8: {
    title: "Life Path 8 – The Achiever",
    keywords: "Success · Power · Authority",
    overview:
      "Life Path 8 carries ambition, confidence and leadership. You are destined for material and professional mastery.",
    strengths: [
      "Business-minded and strategic",
      "Strong leadership abilities",
      "Highly disciplined and goal-oriented",
    ],
    challenges: [
      "Workaholism",
      "Power struggles",
      "Stress and pressure",
    ],
    guidance:
      "Lead with integrity. Power used wisely brings lasting success.",
  },

  9: {
    title: "Life Path 9 – The Humanitarian",
    keywords: "Compassion · Creativity · Emotions",
    overview:
      "Life Path 9 represents universal love, wisdom and emotional depth. You are here to uplift the world.",
    strengths: [
      "Empathy and kindness",
      "Artistic expression",
      "Global, humanitarian thinking",
    ],
    challenges: [
      "Holding onto past pain",
      "Emotional overwhelm",
      "Self-sacrifice",
    ],
    guidance:
      "Release what no longer serves you. Your purpose is to inspire others with your compassion.",
  },

  11: {
    title: "Life Path 11 – The Illuminator",
    keywords: "Spirituality · Intuition · Inspiration",
    overview:
      "A powerful Master Number—11 brings heightened intuition, spiritual awareness and a destiny of inspiring others.",
    strengths: [
      "Strong intuition",
      "Visionary mindset",
      "Magnetic presence",
    ],
    challenges: ["Anxiety", "Self-doubt", "Emotional sensitivity"],
    guidance:
      "Ground your energy. Your intuition is a gift—use it calmly and wisely.",
  },

  22: {
    title: "Life Path 22 – The Master Builder",
    keywords: "Vision · Impact · Mastery",
    overview:
      "22 is the most powerful Life Path. You are capable of building large-scale structures that impact society.",
    strengths: [
      "Extraordinary discipline",
      "Ability to manifest big goals",
      "Practical + visionary mind",
    ],
    challenges: [
      "High pressure",
      "Fear of failure",
      "Over-responsibility",
    ],
    guidance:
      "Break huge goals into steps. Stay grounded and focused.",
  },
};

const Path = () => {
  const [formData, setFormData] = useState({
    firstName: "",
    middleName: "",
    lastName: "",
    year: "2000",
    month: "May",
    day: "26",
    gender: "male" // ✅ DEFAULT, NO UI
  });

  const [resultData, setResultData] = useState(null);
  const [showReport, setShowReport] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const { firstName, lastName, year, month, day } = formData;
    const birthDay = Number(day);
    const birthMonth = new Date(`${month} 1, 2000`).getMonth() + 1;
    const birthYear = Number(year);

    try {
      setLoading(true);

      const { gender } = formData;

      const res = await axios.get(
        `https://core-c343.onrender.com/api/lucky-number` +
        `?firstName=${firstName}` +
        `&lastName=${lastName}` +
        `&birthYear=${birthYear}` +
        `&birthMonth=${birthMonth}` +
        `&birthDay=${birthDay}` +
        `&gender=${gender}`
      );

      setResultData(res.data);
      setShowReport(true);
    } catch (error) {
      setResultData({ error: "Unable to calculate Life Path Number." });
      setShowReport(true);
    } finally {
      setLoading(false);
    }
  };

  const handleTryAgain = () => {
    setResultData(null);
    setShowReport(false);
  };

  const pathNum = resultData?.data?.numerology?.lifePathNumber;
  const profile = pathProfiles[pathNum];

  return (
    <div className="path-container">
      <InnerNav />

      <div className="path-content">
        <Zodiac />

        <div className="left-numerology">
          {/* ------------ FORM VIEW ------------ */}
          {!showReport && (
            <>
              <div className="header">
                <h1>Life Path Number Calculator</h1>
                <p>Understand your soul purpose, personality, and destiny traits.</p>
              </div>

              <div className="form-card">
                <form onSubmit={handleSubmit} className="form-grid">
                  
                  <input
                    name="firstName"
                    placeholder="First Name"
                    value={formData.firstName}
                    onChange={handleChange}
                    required
                  />

                  <input
                    name="middleName"
                    placeholder="Middle Name (Optional)"
                    value={formData.middleName}
                    onChange={handleChange}
                  />

                  <input
                    name="lastName"
                    placeholder="Last Name"
                    value={formData.lastName}
                    onChange={handleChange}
                    required
                  />

                  <div className="dob-grid">
                    <select name="day" value={formData.day} onChange={handleChange}>
                      {[...Array(31)].map((_, i) => (
                        <option key={i + 1}>{i + 1}</option>
                      ))}
                    </select>

                    <select name="month" value={formData.month} onChange={handleChange}>
                      {[
                        "January", "February", "March", "April", "May", "June",
                        "July", "August", "September", "October", "November", "December"
                      ].map((m) => (
                        <option key={m}>{m}</option>
                      ))}
                    </select>

                    <select name="year" value={formData.year} onChange={handleChange}>
                      {Array.from({ length: 110 }).map((_, i) => {
                        const y = 2025 - i;
                        return <option key={y}>{y}</option>;
                      })}
                    </select>
                  </div>
                                    <select
                    name="gender"
                    value={formData.gender}
                    onChange={handleChange}
                    required
                  >
                    <option value="male">Male</option>
                    <option value="female">Female</option>
                    <option value="other">Other</option>
                  </select>

                  <button className="primary-btn" type="submit" disabled={loading}>
                    {loading ? "Calculating..." : "Show My Life Path Number"}
                  </button>
                </form>
              </div>
            </>
          )}

          {/* ------------ REPORT VIEW ------------ */}
          {showReport && (
            <div className="report-card">
              <h1>Your Life Path Number Report</h1>

              {resultData?.error ? (
                <p className="error-text">{resultData.error}</p>
              ) : (
                <>
                  <div className="hero-number-box">
                    <div className="number-circle">{pathNum}</div>
                    <h2>{profile?.title}</h2>
                    <p className="keywords">{profile?.keywords}</p>
                  </div>

                  <div className="report-section">
                    <h3>Overview</h3>
                    <p>{profile?.overview}</p>
                  </div>

                  <div className="report-section">
                    <h3>Strengths</h3>
                    <ul>
                      {profile?.strengths.map((s, i) => (
                        <li key={i}>{s}</li>
                      ))}
                    </ul>
                  </div>

                  <div className="report-section">
                    <h3>Challenges</h3>
                    <ul>
                      {profile?.challenges.map((c, i) => (
                        <li key={i}>{c}</li>
                      ))}
                    </ul>
                  </div>

                  <div className="report-section">
                    <h3>Guidance</h3>
                    <p>{profile?.guidance}</p>
                  </div>
                </>
              )}

              <button className="try-again-btn" onClick={handleTryAgain}>
                Try Again
              </button>
            </div>
          )}
        </div>

        {/* ------------ RIGHT SIDEBAR ------------ */}
        <div className="right-numerology">
          <h4>Popular Tools</h4>
          <div className="right-links">
            <Link to="/numerology/luckynum"><p><img src={arrow}/> Lucky Number</p></Link>
            <Link to="/numerology/chinese-lucky"><p><img src={arrow}/> Chinese Lucky</p></Link>
            <Link to="/numerology/unlucky"><p><img src={arrow}/> Unlucky Number</p></Link>
            <Link to="/numerology/life-path"><p><img src={arrow}/> Life Path</p></Link>
            <Link to="/numerology/destiny"><p><img src={arrow}/> Destiny Number</p></Link>
            <Link to="/numerology/birth"><p><img src={arrow}/> Birth or Root Number</p></Link>
            <Link to="/numerology/soul"><p><img src={arrow}/> Soul Urge Number</p></Link>
            <Link to="/numerology/name"><p><img src={arrow}/> Name Number</p></Link>
            <Link to="/numerology/balance"><p><img src={arrow}/> Balance Number</p></Link>
            <Link to="/numerology/lo-shu-grid"><p><img src={arrow}/> Lo Shu Grid Analysis</p></Link>
            <Link to="/numerology/kua"><p><img src={arrow}/> Kua Number</p></Link>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default Path;
